export const getConfig = state => state.config;
